<template>
  <div class="login-container">
    <h1 style="color: #fff">用户登录</h1>
    <div class="form">
      <el-input
        prefix-icon="el-icon-user"
        placeholder="请输入账号"
        v-model="username"
        size="large"
        autocomplete="off"
        autofocus="off"
        @keyup.enter="handleclick()"
      ></el-input>
      <el-input
        prefix-icon="el-icon-lock"
        show-password="false"
        placeholder="请输入密码"
        v-model="password"
        size="large"
        autocomplete="off"
        @keyup.enter="handleclick()"
      ></el-input>
      <!-- <div style="display: flex;width: 89%;">
                <div style="width: 82%;">
                    <el-input prefix-icon="el-icon-lock" placeholder="请输入验证码" v-model="code" size="large"
                        autocomplete="off" />
                </div>
                <el-button type="primary" size="small"
                    style="margin-left: -10%;height: 49px;width: 26%;margin-top: 10px;"
                    @click="sendmsg()">发送验证码</el-button>
            </div> -->
      <div class="login-option">
        <el-radio-group v-model="accounttype">
          <!-- <el-radio-button label="1" border>运维人员</el-radio-button> -->
          <el-radio-button label="2" border>商户账号</el-radio-button>
          <!-- <el-radio-button label="3" border>星火账户</el-radio-button> -->
        </el-radio-group>
        <el-button type="primary" @click="handleclick()">登录</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { ElMessage } from "element-plus";
import Cookies from "js-cookie";
import constant from "@/constant";
export default {
  data() {
    return {
      username: "",
      password: "",
      code: "",
      accounttype: "2",
    };
  },

  created: function () {
    console.log(Cookies);
    let cookies = Cookies.get("token");
    //let cookies = this.getCookie("token");

    if (cookies) {
      const redirectPath = this.$route.query.redirect || "/home";
      this.$router.push(redirectPath);
    }
  },
  methods: {
    sendmsg() {
      let phoneReg = /^1[3-9]\d{9}$/;
      let phone = this.username;
      if (!phoneReg.test(phone)) {
        ElMessage.error("手机号码格式不正确");
        return false;
      }
      this.axios.post(constant.sendmsg, { phone }).then((response) => {
        console.log(response.data);
        if (response.data == "OK") {
          ElMessage.success("发送成功");
        } else {
          ElMessage.error("发送失败，请联系开发者");
        }
      });
    },
    handleclick() {
      let acctype = this.accounttype;
      this.axios
        .get(constant.login_url, {
          params: {
            username: this.username,
            userpass: this.password,
            accounttype: this.accounttype,
            code: this.code,
          },
        })
        .then((response) => {
          console.log(response.data);
          console.log("name--" + response.data.name);
          console.log("id--" + response.data.id);
          console.log("session--" + response.data.session);
          console.log("role--" + response.data.role);
          if (response.data.message == "NOUSER") {
            this.$message.error("该用户不存在或已失效");
            return false;
          } else if (response.data.message == "failure") {
            this.$message.error("验证码已失效，请重新发送！");
            return false;
          } else if (response.data.message == "errorcode") {
            this.$message.error("验证码错误！");
            return false;
          } else if (response.data.message == "ERROR") {
            this.$message.error("请填写用户名和密码");
            return false;
          } else if (response.data.message == "TEST") {
            return false;
          } else {
            this.$message.success("登录成功");
            Cookies.set("name", response.data.name, { expires: 1 });
            Cookies.set("auth_token", response.data.auth_token, { expires: 1 });
            Cookies.set(
              "token",
              response.data.token,
              { expires: 1 },
              { domain: "merchant.xianniuzu.com" }
            );
            Cookies.set("id", response.data.id, { expires: 1 });
            Cookies.set("show", response.data.show, { expires: 1 });
            Cookies.set("role", response.data.role, { expires: 1 });
            Cookies.set("session", response.data.session, { expires: 1 });
            Cookies.set("IsMerchant", response.data.IsMerchant, { expires: 1 });
            if (response.data.mid)
              Cookies.set("mid", response.data.mid, { expires: 1 });
            if (response.data.role == 2 || response.data.role == 4) {
              Cookies.set("patharr", response.data.patharr, { expires: 1 });
            }
            const redirectPath = this.$route.query.redirect || "/home";
            console.log(acctype);
            if (acctype == 3) {
              this.$router.push("/orderlist");
            } else {
              this.$router.push(redirectPath);
            }
          }
        });
    },
    setCookie(name, value, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 12 * 60 * 60 * 1000);
      var expires = "expires=" + d.toGMTString();
      document.cookie = name + "=" + value + ";" + expires;
    },
    getCookie(name) {
      let ret, m;
      if (typeof name == "string" && name !== "") {
        if (
          (m = String(document.cookie).match(
            new RegExp("(?:^| )" + name + "(?:(?:=([^;]*))|;|$)")
          ))
        ) {
          ret = m[1] ? decodeURIComponent(m[1]) : "";
        }
      }
      return ret;
    },
    DoLogin() {
      var username = getCookie("username");
      if (username) {
        const redirectPath = this.$route.query.redirect || "/home";
        this.$router.push(redirectPath);
      }
      function getCookie(name) {
        let ret, m;
        if (typeof name == "string" && name !== "") {
          if (
            (m = String(document.cookie).match(
              new RegExp("(?:^| )" + name + "(?:(?:=([^;]*))|;|$)")
            ))
          ) {
            ret = m[1] ? decodeURIComponent(m[1]) : "";
          }
        }
        return ret;
      }
    },
  },
};
</script>

<style scoped>
h1 {
  margin-top: 10%;
}

.input-block {
  background: #2d3a4b;
}

.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: 30%;
}

.login-option {
  width: 85%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
}

.el-input {
  border-radius: 3px;
  color: #fff;
}

.el-input {
  margin: 10px;
  width: 85%;
}

.el-input /deep/ .el-input__inner {
  background-color: #273241;
  line-height: 50px;
  height: 50px;
  border: 1px solid #7e7777;
  color: #fff;
}

.el-input /deep/ .el-input__icon {
  line-height: 50px;
}

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: #6e777a;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
</style>
